var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{staticClass:"border border-gray-400 rounded-3xl px-10 py-8"})
}
var staticRenderFns = []

export { render, staticRenderFns }